import { styled } from "@mui/material"

const BlockingScreenLayer = styled('div')(({zIndex = 1, backgroundOpacity = 0.2}) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: zIndex,
    backgroundColor: `rgba(0, 0, 0, ${backgroundOpacity})` 
}));

export default BlockingScreenLayer;